import { Injectable, NgZone } from '@angular/core';

import { Capacitor, } from "@capacitor/core";
import { App } from "@capacitor/app";
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { NavController } from '@ionic/angular';

import { StorageService } from '../storage/storage.service';
import { GlobalVar } from '../global/globalvar';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public notificationsList = [];
  public receivedNotificationslist = [];
  public notificationsCount: number;

  constructor(
    private navCtrl: NavController,
    public zone: NgZone,
    public apiService: ApiService,
    public storageService: StorageService,
    public globalvar: GlobalVar,
  ) { }


  async isPermissionsAllowed() {
    let pushAvailability = false;
    if (Capacitor.getPlatform() !== "web") {
      pushAvailability = (await PushNotifications.checkPermissions()).receive === "granted" ? true : false;
    }
    return pushAvailability;
  }

  initPush() {
    if (Capacitor.getPlatform() !== "web") {
      PushNotifications.checkPermissions().then((permission) => {
        if (permission.receive !== "granted") {
          PushNotifications.requestPermissions().then((permission) => {
            if (permission.receive === "granted") {
              this.registerPush();
            }
          });
        } else {
          this.registerPush();
        }
      });
    }
  }

  async registerPush() {
    await PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    await PushNotifications.register();

    // On success, we should be able to receive notifications
    await PushNotifications.addListener('registration', async (token: Token) => {
      console.info("Registration token: ", token.value);
      let version = null;
      let has_permission = null;

      if (Capacitor.getPlatform() !== 'web') {
        const info = await App.getInfo();
        version = info.version;

        const permission = await PushNotifications.checkPermissions();
        has_permission = permission.receive === 'granted' ? 1 : 0;
      }

      const data = {
        push_key: token.value,
        platform: Capacitor.getPlatform(),
        has_permission: has_permission
      }

      return this.apiService.post(`refresh-push-token/${this.globalvar._user.id}`, data).then((response: any) => {
        return response;
      }, (err) => {
        console.error(err);
      });
    });

    // Some issue with our setup and push will not work
    await PushNotifications.addListener('registrationError', (err: any) => {
      console.error("Error on registration: ", err.error);
    });

    // Show us the notification payload if the app is open on our device
    await PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      // console.log("Push notification received: ", notification);
      // this.notificationsList.push(notification);
      if (!notification.hasOwnProperty('group')) {
        this.setReceivedNotifications(notification);
      }
    });

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed', (entireNotification: ActionPerformed) => {
      // console.log("Push action performed: ", entireNotification);

      if (entireNotification.actionId === "tap") {
        const notification = entireNotification.notification?.data;
        const type = notification?.type ?? notification?.['gcm.notification.type'];
        // const notificationId = notification?.notId ? notification?.notId : notification?.["gcm.notification.thread-id"];
        // const funcId = notification?.funcId ? notification?.funcId : '';

        this.checkType(type);
      }
    });
  }

  checkType(type) {
    switch (type) {
      case "chatmessage":
        this.zone.run(() => {
          this.globalvar.notificationRoute = 'tabs/chat';
          this.navCtrl.navigateRoot([`tabs/chat`], { replaceUrl: true })
        });
        break;
      case "checkin":
        this.zone.run(() => {
          this.globalvar.notificationRoute = 'tabs/checkin';
          this.navCtrl.navigateRoot([`tabs/checkin`], { replaceUrl: true })
        });
        break;
      default:
        break;
    }
  }

  async getAllNotifications() {
    await this.getReceivedNotifications();
    await this.getDeliveredNotifications();
  }

  async getDeliveredNotifications() {
    let deliveredNotifications = await PushNotifications.getDeliveredNotifications();
    let notifications = deliveredNotifications.notifications;

    for (let index = 0; index < notifications.length; index++) {
      const notification = notifications[index];
      const tag = notification.tag;

      // if (tag.startsWith('FCM-Notification:')){
      const found = this.notificationsList.find((obj) => {
        return obj.tag === notification.tag;
      });
      if (!found) {
        if (!notification.hasOwnProperty('group')) {
          this.notificationsList.push(notification);
        }
      }
      // }
    }

    // TODO If delivered notification doesn't exists anylonger then remove it from notificationsList

    this.getNotificationsListCount();

    return this.notificationsList;
  }

  async setReceivedNotifications(notification) {
    // TODO send local push notification
    // console.log('Received notification:' + JSON.stringify(notification));
    if ((this.receivedNotificationslist || []).length > 0) {
      const found = this.receivedNotificationslist.find((obj) => {
        return obj.id === notification.id;
      });
      if (!found) {
        // console.log('New notification to list');
        this.receivedNotificationslist.push(notification);
      }
    } else {
      this.receivedNotificationslist = [];
      this.receivedNotificationslist.push(notification);
    }

    this.storageService.set(`RECEIVED_NOTIFICATIONS`, this.receivedNotificationslist).then(() => {
      // console.log('RECEIVED_NOTIFICATIONS:' + this.receivedNotificationslist);
      this.getReceivedNotifications();
    });

    return this.receivedNotificationslist;
  }

  async getReceivedNotifications() {
    if (!this.receivedNotificationslist) {
      this.storageService.get(`RECEIVED_NOTIFICATIONS`).then(async (notifications) => {
        this.receivedNotificationslist = notifications;
        // console.log('RECEIVED_NOTIFICATIONS: ' + this.receivedNotificationslist);
      });
    }

    for (let index = 0; index < this.receivedNotificationslist.length; index++) {
      const notification = this.receivedNotificationslist[index];
      const tag = notification.tag;

      // if (tag.startsWith('FCM-Notification:')){
      const found = this.notificationsList.find((obj) => {
        return obj.tag === notification.tag;
      });
      if (!found) {
        if (!notification.hasOwnProperty('group')) {
          this.notificationsList.push(notification);
        }
      }
      // }
    }

    this.getNotificationsListCount();

    return this.notificationsList;
  }

  async getNotificationsListCount() {
    this.notificationsCount = this.notificationsList.length;
    console.warn(this.notificationsCount);
    return this.notificationsCount;
  }

  async removeAllDeliveredNotifications() {
    await PushNotifications.removeAllDeliveredNotifications();
  }

  async removeDeliveredNotifications(notification) {
    // TODO remove this item from list
    await PushNotifications.removeDeliveredNotifications(notification);
  }

  async removeReceivedNotifications(notification) {
    // console.log('Remove this notification: ' + notification);

    this.notificationsList = this.notificationsList.filter(obj => {
      return obj.id !== notification.id;
    });

    this.receivedNotificationslist = this.receivedNotificationslist.filter(obj => {
      return obj.id !== notification.id;
    });

    this.storageService.set(`RECEIVED_NOTIFICATIONS`, this.receivedNotificationslist).then(() => {
      // console.log('NEW RECEIVED_NOTIFICATIONS:' + this.receivedNotificationslist);
    });

    this.getNotificationsListCount();
  }
}
